<template>
	<div
		class="label-container"
		:class="AddLblClass"
		v-if="$slots.leading || $slots.trailing"
	>
		<slot name="leading"></slot>
		<label class="label" :for="forElementId" v-html="labelText" />
		<slot name="trailing"></slot>
	</div>
	<label v-else class="label" :for="forElementId" v-html="labelText" />
</template>

<script>
export default {
	name: 'Label',
	props: {
		labelText: {
			type: String,
			default: ''
		},
		forElementId: {
			type: [String, Number],
			default: ''
		},
		iconClassName: {
			type: String
		},
		iconTooltipText: {
			type: String
		},
		/**
		 * When the parent container is disabled, the label-container by default is also disabled
		 * All inner items become unclickable
		 * This option prevents the inner items from being unclickable by adding a class (enabled) to the container
		 */
		preventLblDisable: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		showIcon() {
			return (
				this.iconClassName !== undefined && this.iconClassName !== ''
			);
		},
		AddLblClass() {
			return this.preventLblDisable ? 'enabled' : '';
		}
	}
};
</script>

<style lang="scss" scoped>
.label {
	color: var(--field-fg);
	font-size: $field-font-size;
	font-weight: $bold-font-weight;

	&:deep(mark) {
		background: var(--bg-brand-2-tint);
		color: var(--bg-brand-2-tint-fg-2);
	}
}
.label-container {
	display: flex;
	align-items: flex-start;
	gap: $gutter-md;
	position: relative;
	font-size: $field-font-size;

	&:deep(i) {
		margin-top: 1px;
	}
}
</style>
